const DEFAULT_API_BASE = 'https://middleschoolcounts.duckdns.org';

export function getPrintApiBase() {
  const fromEnv = process.env.REACT_APP_PRINT_API_BASE;
  const base = (fromEnv && fromEnv.trim()) || DEFAULT_API_BASE;
  return base.replace(/\/$/, '');
}

function buildHeaders() {
  const token = process.env.REACT_APP_PRINT_API_TOKEN;
  return token ? { 'X-Print-Api-Key': token } : {};
}

async function readJsonResponse(response) {
  const text = await response.text();
  let payload = null;

  try {
    payload = text ? JSON.parse(text) : null;
  } catch (error) {
    payload = { message: text || response.statusText };
  }

  if (!response.ok) {
    throw new Error(payload?.message || payload?.error || 'Request failed.');
  }

  return payload;
}

export async function fetchPrinters() {
  const response = await fetch(`${getPrintApiBase()}/api/printers`, { headers: buildHeaders() });
  return readJsonResponse(response);
}

export async function submitPrintJob({ file = null, printerIds, note = '', printText = '', rotatePhoto = false, submittedBy = '' }) {
  const textToPrint = (printText || note || '').trim();

  if (!file && !textToPrint) {
    throw new Error('Please choose a photo, enter text to print, or both.');
  }

  if (!Array.isArray(printerIds) || printerIds.length === 0) {
    throw new Error('Please select at least one printer.');
  }

  const formData = new FormData();
  if (file) {
    formData.append('image', file);
  }
  formData.append('printerIds', JSON.stringify(printerIds));
  formData.append('note', note);
  formData.append('printText', textToPrint);
  formData.append('rotatePhoto', rotatePhoto ? 'true' : 'false');
  formData.append('submittedBy', submittedBy);

  const response = await fetch(`${getPrintApiBase()}/api/jobs`, {
    method: 'POST',
    headers: buildHeaders(),
    body: formData,
  });

  return readJsonResponse(response);
}


export async function fetchDashboard() {
  const response = await fetch(`${getPrintApiBase()}/api/dashboard`, { headers: buildHeaders() });
  return readJsonResponse(response);
}
